import { useCallback, useEffect, useMemo, useRef } from 'react';
import { useDispatch } from 'react-redux';
import PropTypes from 'prop-types';

import { WithTooltip } from 'basic-components';
import { Visible } from 'basic-components/icons';
import { DataScienceQuery } from 'dashboard-services/api/dataScience';
import Query from 'dashboard-services/api/Query';

import getApiConfig from 'api/ApiConfig';

import { useMutation } from '@tanstack/react-query';

const useResolveExpression = ({ getQueryBuilder, paramName, params, value }) =>
  useMutation({
    ...DataScienceQuery.QUERIES.processTaskExpression(
      getQueryBuilder,
      {
        paramName,
        params: Object.fromEntries(Object.entries(params || {}).map(([k, v]) => typeof v === "object" ? [k, JSON.stringify(v)] : [k, v])),
        value
      }
    ),
    enabled: false
  })
const PreviewExpression = ({ name, value, getAllParams, tooltipPosition = "left" }) => {
  const dispatch = useDispatch(),
        getApiConfigLocal = useCallback(() => dispatch(getApiConfig()), [dispatch]),
        getQueryBuilder = useCallback(() => 
          new Query.Builder(getApiConfigLocal())
            .withFetching(false)
        , [getApiConfigLocal]),
        timeoutRef = useRef(),
        { data: resolvedExpressionRaw, mutate } = useResolveExpression({ getQueryBuilder, paramName: name, params: getAllParams(), value }),
        resolvedExpression = useMemo(() => resolvedExpressionRaw?.response || "ERROR", [resolvedExpressionRaw])

  useEffect(() => {
    clearTimeout(timeoutRef.current)
    timeoutRef.current = setTimeout(() => mutate(), 500)
  }, [name, getAllParams, value, mutate])

  return (
    <WithTooltip
        data-place={tooltipPosition}
        text={resolvedExpression}
    >
      <div className="data-science__pipeline-creator__body__options__resolver__header__controls__control">
        <Visible
            color="blue-bright"
            height={16}
            width={16}
        />
      </div>
    </WithTooltip>
  )
}

PreviewExpression.propTypes = {
  getAllParams: PropTypes.func.isRequired,
  name: PropTypes.string.isRequired,
  tooltipPosition: PropTypes.string,
  value: PropTypes.any.isRequired
}

export default PreviewExpression;